import type * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSharedCompanyQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String']['input'];
}>;


export type GetSharedCompanyQueryPage = { readonly __typename?: 'RootQueryType', readonly sharedCompany?: { readonly __typename?: 'SharedCompany', readonly name: string } | null, readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly type?: Types.AccountsUserType | null, readonly isWizardFinished: boolean, readonly profile?: { readonly __typename?: 'AccountsProfile', readonly id: string } | null } | null };


export const GetSharedCompanyDocument = gql`
    query GetSharedCompany($uuid: String!) {
  sharedCompany(uuid: $uuid) {
    name
  }
  currentUser {
    type
    isWizardFinished
    profile {
      id
    }
  }
}
    `;

/**
 * __useGetSharedCompanyQuery__
 *
 * To run a query within a React component, call `useGetSharedCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedCompanyQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetSharedCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables> & ({ variables: GetSharedCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>(GetSharedCompanyDocument, options);
      }
export function useGetSharedCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>(GetSharedCompanyDocument, options);
        }
export function useGetSharedCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>(GetSharedCompanyDocument, options);
        }
export type GetSharedCompanyQueryHookResult = ReturnType<typeof useGetSharedCompanyQuery>;
export type GetSharedCompanyLazyQueryHookResult = ReturnType<typeof useGetSharedCompanyLazyQuery>;
export type GetSharedCompanySuspenseQueryHookResult = ReturnType<typeof useGetSharedCompanySuspenseQuery>;
export type GetSharedCompanyQueryResult = Apollo.QueryResult<GetSharedCompanyQueryPage, GetSharedCompanyQueryVariables>;